import React from "react";
import { Container, Divider, Paper, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  interval: {
    marginTop: theme.spacing(5),
  },
  paper: {
    alignItems: "center",
    marginTop: theme.spacing(5),
    margin: theme.spacing(3),
    padding: theme.spacing(8),
  },
}));

export default function Manual(props) {
  const userInfo = props.userInfo;
  const classes = useStyles();

  return (
    <React.Fragment>
      <Alert variant="outlined" severity="info">
        このページでは各システムの使い方を動画で説明しています。
        <br />
        <br />
        - システムの概要
        <br />
        - ツールを実際に使った出品までの流れ
        <br />
        - ツールの初期導入
        <br />
        - 商品リスト作成ツール
        <br />
        - 画像加工ツール
        <br />
        - 出品ツール
        <br />
        - BuyManager
        <br />
        - 在庫管理システム
        <br />- ツールのアップデート方法
      </Alert>

      <div className={classes.interval}>
        <Typography variant="h4" align="center" gutterBottom>
          マニュアル
        </Typography>
        <iframe
          title="Manual"
          src="https://hp.pluselect.com/system"
          width="100%"
          height="800"
        />
      </div>

      <Container className={classes.interval}>
        <Paper className={classes.paper} variant="outlined">
          <Typography variant="h4" align="center" gutterBottom>
            システムサポートLINE@
          </Typography>
          <Divider />
          <Typography variant="body">
            システムの使い方やエラーなど、システムの利用に関するお問い合わせはこちらからご連絡くださいませ。
            <br />
            公式LINE@よりも素早く対応が可能になります。
            <br />
            まず最初に下のLINE@に登録して「
            <Typography variant="caption" color="error">
              ご登録のメールアドレス
            </Typography>
            」または、「
            <Typography variant="caption" color="error">
              {userInfo ? userInfo.id : null}
            </Typography>
            」をメッセージを送ってください。
            <br />
            アカウントの識別の為に必要な数字ですので、間違いの無いようにお気をつけください。
          </Typography>

          <a href="https://lin.ee/cFX5Nlq">
            <img
              src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png"
              alt="友だち追加"
              height="36"
              border="0"
            />
          </a>
        </Paper>
      </Container>
    </React.Fragment>
  );
}
